import {processApiRequest} from "../../Common/saga";
import * as ACTION from "../constants";
import apiService from "../apiService";

export function* fetchListWarehouseStaff(action) {
	yield processApiRequest(ACTION.FETCH_LIST_WAREHOUSE_STAFF, () => apiService.getListWarehouseStaff(action.payload), action.payload);
}
